module.exports = __webpack_public_path__ + "img/logo.6c0c3cb0.png";